import useSettingsStore from '../store/settingsStore'
import useBitsStore from '../store/bitsStore'
import '../styles/BitsVariants.css'

// CSS-rendered insect sub-components
function LadybugBody() {
  return (
    <div className="insect-art ladybug-art">
      <div className="ladybug-head" />
      <div className="ladybug-body">
        <div className="ladybug-wing-line" />
        <div className="ladybug-spot spot-1" />
        <div className="ladybug-spot spot-2" />
        <div className="ladybug-spot spot-3" />
        <div className="ladybug-spot spot-4" />
      </div>
      <div className="ladybug-antenna antenna-l" />
      <div className="ladybug-antenna antenna-r" />
    </div>
  )
}

function ButterflyBody() {
  return (
    <div className="insect-art butterfly-art">
      <div className="butterfly-body-center" />
      <div className="butterfly-wing wing-tl" />
      <div className="butterfly-wing wing-tr" />
      <div className="butterfly-wing wing-bl" />
      <div className="butterfly-wing wing-br" />
      <div className="butterfly-antenna antenna-l" />
      <div className="butterfly-antenna antenna-r" />
    </div>
  )
}

function BeeBody() {
  return (
    <div className="insect-art bee-art">
      <div className="bee-head">
        <div className="bee-eye eye-l" />
        <div className="bee-eye eye-r" />
      </div>
      <div className="bee-body">
        <div className="bee-stripe stripe-1" />
        <div className="bee-stripe stripe-2" />
        <div className="bee-stripe stripe-3" />
      </div>
      <div className="bee-wing wing-l" />
      <div className="bee-wing wing-r" />
      <div className="bee-stinger" />
    </div>
  )
}

function CaterpillarBody() {
  return (
    <div className="insect-art caterpillar-art">
      <div className="caterpillar-head">
        <div className="caterpillar-eye eye-l" />
        <div className="caterpillar-eye eye-r" />
        <div className="caterpillar-antenna antenna-l" />
        <div className="caterpillar-antenna antenna-r" />
      </div>
      <div className="caterpillar-segment seg-1" />
      <div className="caterpillar-segment seg-2" />
      <div className="caterpillar-segment seg-3" />
      <div className="caterpillar-segment seg-4" />
    </div>
  )
}

function FireflyBody() {
  return (
    <div className="insect-art firefly-art">
      <div className="firefly-head" />
      <div className="firefly-body-main" />
      <div className="firefly-glow-bulb" />
      <div className="firefly-wing wing-l" />
      <div className="firefly-wing wing-r" />
    </div>
  )
}

function BeetleBody() {
  return (
    <div className="insect-art beetle-art">
      <div className="beetle-head">
        <div className="beetle-mandible mandible-l" />
        <div className="beetle-mandible mandible-r" />
      </div>
      <div className="beetle-shell">
        <div className="beetle-shell-line" />
      </div>
      <div className="beetle-leg leg-1" />
      <div className="beetle-leg leg-2" />
      <div className="beetle-leg leg-3" />
    </div>
  )
}

function DragonflyBody() {
  return (
    <div className="insect-art dragonfly-art">
      <div className="dragonfly-head">
        <div className="dragonfly-eye eye-l" />
        <div className="dragonfly-eye eye-r" />
      </div>
      <div className="dragonfly-thorax" />
      <div className="dragonfly-abdomen" />
      <div className="dragonfly-wing wing-tl" />
      <div className="dragonfly-wing wing-tr" />
      <div className="dragonfly-wing wing-bl" />
      <div className="dragonfly-wing wing-br" />
    </div>
  )
}

function SnailBody() {
  return (
    <div className="insect-art snail-art">
      <div className="snail-shell-user">
        <div className="snail-shell-spiral" />
      </div>
      <div className="snail-body-user">
        <div className="snail-eye-stalk stalk-l">
          <div className="snail-eye" />
        </div>
        <div className="snail-eye-stalk stalk-r">
          <div className="snail-eye" />
        </div>
      </div>
    </div>
  )
}

function WormBody() {
  return (
    <div className="insect-art worm-art">
      <div className="worm-segment seg-1" />
      <div className="worm-segment seg-2" />
      <div className="worm-segment seg-3" />
      <div className="worm-segment seg-4" />
      <div className="worm-segment seg-5" />
      <div className="worm-head">
        <div className="worm-eye eye-l" />
        <div className="worm-eye eye-r" />
      </div>
    </div>
  )
}

// Username with VIP badge + custom name color
function InsectUsername({ userId, username }) {
  const hasVip = useBitsStore((state) => state.hasReachedPerk(userId, 'vip_badge'))
  const hasNameColor = useBitsStore((state) => state.hasCosmetic(userId, 'name_color'))
  const nameColorValue = hasNameColor ? getNameColor(userId) : undefined

  return (
    <div className="entity-username" style={nameColorValue ? { color: nameColorValue } : undefined}>
      {hasVip && <span className="vip-badge">⭐</span>}
      {username}
    </div>
  )
}

function getNameColor(userId) {
  const colors = ['#ff6b6b', '#ffd93d', '#6bcf7f', '#74b9ff', '#a29bfe', '#fd79a8', '#ff9ff3', '#54a0ff', '#5f27cd', '#01a3a4']
  let hash = 0
  for (let i = 0; i < userId.length; i++) {
    hash = userId.charCodeAt(i) + ((hash << 5) - hash)
  }
  return colors[Math.abs(hash) % colors.length]
}

// ============================================
// LEGENDARY INSECTS (500 bits)
// ============================================

function MothBody() {
  return (
    <div className="insect-art moth-art legendary-insect">
      <div className="moth-body-center" />
      <div className="moth-wing wing-l">
        <div className="moth-wing-pattern" />
        <div className="moth-eye-spot" />
      </div>
      <div className="moth-wing wing-r">
        <div className="moth-wing-pattern" />
        <div className="moth-eye-spot" />
      </div>
      <div className="moth-antenna antenna-l" />
      <div className="moth-antenna antenna-r" />
      <div className="moth-dust dust-1" />
      <div className="moth-dust dust-2" />
      <div className="moth-dust dust-3" />
    </div>
  )
}

function MantisBody() {
  return (
    <div className="insect-art mantis-art legendary-insect">
      <div className="mantis-head">
        <div className="mantis-eye eye-l" />
        <div className="mantis-eye eye-r" />
        <div className="mantis-antenna antenna-l" />
        <div className="mantis-antenna antenna-r" />
      </div>
      <div className="mantis-thorax" />
      <div className="mantis-abdomen" />
      <div className="mantis-arm arm-l">
        <div className="mantis-claw" />
      </div>
      <div className="mantis-arm arm-r">
        <div className="mantis-claw" />
      </div>
      <div className="mantis-leg leg-1" />
      <div className="mantis-leg leg-2" />
      <div className="mantis-leg leg-3" />
      <div className="mantis-leg leg-4" />
    </div>
  )
}

function ScorpionBody() {
  return (
    <div className="insect-art scorpion-art legendary-insect">
      <div className="scorpion-head">
        <div className="scorpion-eye eye-l" />
        <div className="scorpion-eye eye-r" />
      </div>
      <div className="scorpion-body-main" />
      <div className="scorpion-pincer pincer-l">
        <div className="pincer-claw" />
      </div>
      <div className="scorpion-pincer pincer-r">
        <div className="pincer-claw" />
      </div>
      <div className="scorpion-tail">
        <div className="tail-seg seg-1" />
        <div className="tail-seg seg-2" />
        <div className="tail-seg seg-3" />
        <div className="scorpion-stinger" />
      </div>
      <div className="scorpion-leg leg-1" />
      <div className="scorpion-leg leg-2" />
      <div className="scorpion-leg leg-3" />
    </div>
  )
}

const INSECT_RENDERERS = {
  ladybug: LadybugBody,
  butterfly: ButterflyBody,
  bee: BeeBody,
  caterpillar: CaterpillarBody,
  firefly: FireflyBody,
  beetle: BeetleBody,
  dragonfly: DragonflyBody,
  snail: SnailBody,
  worm: WormBody,
  moth: MothBody,
  mantis: MantisBody,
  scorpion: ScorpionBody
}

// ============================================
// INSECT HATS (CSS-only, positioned above body)
// ============================================

function InsectHat({ type }) {
  if (type === 'birthday') {
    return (
      <div className="insect-hat hat-birthday">
        <div className="hat-cone" />
        <div className="hat-pom" />
        <div className="hat-band" />
      </div>
    )
  }
  if (type === 'tophat') {
    return (
      <div className="insect-hat hat-tophat">
        <div className="tophat-crown" />
        <div className="tophat-brim" />
        <div className="tophat-band" />
      </div>
    )
  }
  if (type === 'crown') {
    return (
      <div className="insect-hat hat-crown">
        <div className="crown-base" />
        <div className="crown-point point-1" />
        <div className="crown-point point-2" />
        <div className="crown-point point-3" />
        <div className="crown-gem" />
      </div>
    )
  }
  if (type === 'santa') {
    return (
      <div className="insect-hat hat-santa">
        <div className="santa-base" />
        <div className="santa-tip" />
        <div className="santa-pom" />
        <div className="santa-brim" />
      </div>
    )
  }
  if (type === 'cowboy') {
    return (
      <div className="insect-hat hat-cowboy">
        <div className="cowboy-crown" />
        <div className="cowboy-brim" />
        <div className="cowboy-band" />
      </div>
    )
  }
  if (type === 'wizard') {
    return (
      <div className="insect-hat hat-wizard">
        <div className="wizard-cone" />
        <div className="wizard-brim" />
        <div className="wizard-star star-1">✦</div>
        <div className="wizard-star star-2">✦</div>
      </div>
    )
  }
  return null
}

export function TerrariumInsect({ insect }) {
  const settings = useSettingsStore((state) => state.settings)

  const {
    insectType, position, facingLeft, isFlying, isLanded,
    isWalking, chatMessage, spawning, despawning,
    isPollinatingUserId, isVisiting,
    isDancing, isPetted, isSinging, isNuzzling, isStinging,
    hat = null,
    variant = 'default'
  } = insect

  const InsectRenderer = INSECT_RENDERERS[insectType] || LadybugBody

  const className = [
    'terrarium-insect',
    `insect-${insectType}`,
    spawning ? 'spawning' : '',
    despawning ? 'despawning' : '',
    isFlying ? 'flying' : '',
    isWalking ? 'walking' : '',
    isLanded ? 'landed' : '',
    isPollinatingUserId ? 'pollinating' : '',
    isVisiting ? 'visiting' : '',
    isDancing ? 'dancing' : '',
    isPetted ? 'petted' : '',
    isSinging ? 'singing' : '',
    isNuzzling ? 'nuzzling' : '',
    isStinging ? 'stinging' : '',
    facingLeft ? 'facing-left' : '',
    variant !== 'default' ? `variant-${variant}` : ''
  ].filter(Boolean).join(' ')

  return (
    <div
      className={className}
      style={{
        left: `${position.x}%`,
        bottom: `${position.y}%`
      }}
    >
      {settings.showChatBubbles && chatMessage && (
        <div className="entity-chat-bubble">
          <span>{chatMessage}</span>
        </div>
      )}
      {settings.showUsernames && (
        <InsectUsername userId={insect.userId} username={insect.username} />
      )}
      {hat && <InsectHat type={hat} />}
      <div className="insect-body-wrapper">
        <InsectRenderer />
      </div>
      {isPollinatingUserId && (
        <div className="pollinate-particles">
          {Array.from({ length: 4 }, (_, i) => (
            <div key={i} className="pollen-particle" style={{
              animationDelay: `${i * 0.2}s`
            }} />
          ))}
        </div>
      )}
      {isSinging && (
        <div className="sing-notes">
          <span className="music-note note-1">♪</span>
          <span className="music-note note-2">♫</span>
          <span className="music-note note-3">♪</span>
        </div>
      )}
      {isPetted && (
        <div className="pet-hearts">
          <span className="pet-heart heart-1">♥</span>
          <span className="pet-heart heart-2">♥</span>
          <span className="pet-heart heart-3">♥</span>
        </div>
      )}
      {isStinging && (
        <div className="sting-effect">
          <span className="sting-icon">💉</span>
          <span className="sting-zap zap-1">⚡</span>
          <span className="sting-zap zap-2">⚡</span>
        </div>
      )}
    </div>
  )
}

export default TerrariumInsect